export const redirectToFrontPage = () => {
  window.location.href = '/';
};
